import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

function ArchivedProjectsView({
  filteredArchivedProjects,
  archivedSearchText,
  setArchivedSearchText
}) {
  return (
    <div>
      <h2>Arşivlenen Projeler</h2>

      <input
        placeholder="Firma, proje adı, teknopark veya STB kodu ara..."
        value={archivedSearchText}
        onChange={(e) => setArchivedSearchText(e.target.value)}
        style={{
          width: "100%",
          padding: "14px 18px",
          marginTop: 18,
          marginBottom: 20,
          borderRadius: 14,
          border: "1px solid #dbe2ea",
          background: "#fff",
          fontSize: 14,
          outline: "none",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)"
        }}
      />

      <div
        style={{
          display: "grid",
          gap: 12,
          marginTop: 20
        }}
      >
        {filteredArchivedProjects.map((project) => (
          <div
            key={project.id}
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 14,
              padding: 18,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div>
              <strong>
                {project.firmaAdi} - {project.projeAdi}
              </strong>

              <div
                style={{
                  marginTop: 6,
                  fontSize: 14,
                  color: "#666"
                }}
              >
                {project.teknoparkAdi} • {project.projeStbKodu}

                <div
                  style={{
                    marginTop: 6,
                    fontSize: 13,
                    color: "#6b7280"
                  }}
                >
                  Arşivleyen: {project.archivedBy || "-"} • Tarih:{" "}
                  {project.archivedAt?.toDate
                    ? project.archivedAt
                        .toDate()
                        .toLocaleString("tr-TR")
                    : "-"}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button
                onClick={async () => {
                  await updateDoc(doc(db, "projects", project.id), {
                    isArchived: false
                  });

                  alert("Proje arşivden geri alındı.");
                }}
                style={{
                  padding: "10px 16px",
                  borderRadius: 10,
                  border: "none",
                  background: "#2563eb",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                Geri Al
              </button>

              <button
                onClick={async () => {
                  const confirmDelete = await window.appConfirm(
                    "Bu projeyi kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                    { title: "Kalıcı silme", type: "danger", confirmText: "Kalıcı sil" }
                  );

                  if (!confirmDelete) return;

                  await deleteDoc(doc(db, "projects", project.id));

                  alert("Proje kalıcı olarak silindi.");
                }}
                style={{
                  padding: "10px 16px",
                  borderRadius: 10,
                  border: "none",
                  background: "#ef4444",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                Kalıcı Sil
              </button>
            </div>
          </div>
        ))}

        {filteredArchivedProjects.length === 0 && (
          <div
            style={{
              padding: 20,
              background: "#fff",
              borderRadius: 14,
              color: "#666"
            }}
          >
            Arşivlenmiş proje bulunmuyor.
          </div>
        )}
      </div>
    </div>
  );
}

export default ArchivedProjectsView;